import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import HtmlToReactParser from 'html-react-parser';
import { Tabs, TabsContent } from '../../components/ui/tabs';
import LevelSelector from '../components/LevelSelector';
import PathSelector from '../components/PathSelector';
import AlumniParser from '../admin/detail/TipTap/AlumniParser';
import { motion } from 'framer-motion';
import { Alumni, Content, Path } from '../../lib/types';

function MajorDetailBtm({
  selectedPath,
  selectedPathId,
  paths,
  selectedLevel,
  setSelectedLevel,
  handleChange,
  contentArr,
  alumniSet,
}: {
  paths: Path[] | [];
  selectedPath: Path | null | undefined;
  selectedPathId: number | null | undefined;
  selectedLevel: string;
  setSelectedLevel: (level: string) => void;
  handleChange: (pathId: string) => void;
  contentArr: Content[] | null | undefined;
  alumniSet: Alumni[] | [];
}) {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Card className="max-w-[1200px] mx-auto py-5 styled-link">
        {(selectedPath === null || selectedPathId === null) && (
          <div className="flex items-center justify-center flex-col border-0 shadow-0 my-5">
            <span className="font-bold text-4xl text-wrap w-75 text-center">
              No Paths Found For major!
            </span>
          </div>
        )}
        {selectedPath !== null && selectedPathId !== null && (
          <>
            <CardHeader className="flex-row justify-between px-2 md:px-5 py-0 gap-4 md:gap-0">
              <div>
                <CardTitle className="text-xl xs:text-3xl sm:text-4xl">
                  Pathway to Careers
                </CardTitle>
                <CardTitle className="text-lg xs:text-2xl mt-2">
                  {selectedPath?.name}
                </CardTitle>
              </div>
              <div className="flex gap-2 w-60 xs:w-96 flex-wrap xs:flex-nowrap lg:w-auto">
                <PathSelector
                  selectedPath={selectedPath}
                  paths={paths}
                  handleChange={handleChange}
                />
                <LevelSelector
                  selectedLevel={selectedLevel}
                  setSelectedLevel={setSelectedLevel}
                />
              </div>
            </CardHeader>
            <div className="flex items-center justify-between p-1 xs:p-6 border-b-1 border-gray-200"></div>
            <CardContent className="py-2 xs:py-4">
              <Tabs
                value={selectedLevel}
                defaultValue="early"
                className="border-black w-[100%]"
              >
                {contentArr?.map((content: Content, index: number) => {
                  return (
                    <>
                      <TabsContent
                        key={index}
                        className="px-0"
                        value={content.level}
                      >
                        {HtmlToReactParser(content.rtf)}
                      </TabsContent>
                    </>
                  );
                })}
              </Tabs>
              <AlumniParser alumniSet={alumniSet} />
            </CardContent>
          </>
        )}
      </Card>
    </motion.section>
  );
}

export default MajorDetailBtm;
